export function formatDocumentParts(document: string): {
	label: "CPF" | "CNPJ";
	value: string;
} {
	const digits = document.replace(/\D/g, "");

	if (digits.length === 11) {
		return {
			label: "CPF",
			value: digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4"),
		};
	}

	return {
		label: "CNPJ",
		value: digits.replace(
			/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
			"$1.$2.$3/$4-$5",
		),
	};
}

export function formatDocumentLabel(document: string): string {
	const { label, value } = formatDocumentParts(document);
	return `${label}: ${value}`;
}
